import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=1ef440e3"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=1ef440e3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports